import React, { ReactNode } from "react";
import {
  DesignDialog,
  DesignDialogButton,
} from "../../common/dashboard/DesignDialog";

export type MemberActionSuccessDialogState = {
  title: string;
  tone: "green" | "red";
  /** Icon colour when the design asks for another one (Cancel Member Renewal: brand yellow). */
  iconColor?: string;
  body?: ReactNode;
  highlights?: string[];
  note?: ReactNode;
  actionLabel?: string;
  onAction?: () => void;
  secondaryActionLabel?: string;
  onSecondaryAction?: () => void;
  actionLoading?: boolean;
  actionError?: string;
  refreshWarning?: string;
};

export type MemberActionSuccessDialogProps = {
  onClose: () => void;
  state: MemberActionSuccessDialogState | null;
};

const MemberActionSuccessDialog = ({
  onClose,
  state,
}: MemberActionSuccessDialogProps) => (
  <DesignDialog
    open={Boolean(state)}
    onClose={onClose}
    title={state?.title}
    message={state?.body}
    highlights={state?.highlights}
    note={state?.note}
    icon="success"
    iconColor={state?.iconColor}
    busy={state?.actionLoading}
    closeLabel="Close success confirmation"
    actions={
      state?.actionLabel || state?.secondaryActionLabel ? (
        <>
          {state.actionLabel && state.onAction && (
            <DesignDialogButton
              disabled={state.actionLoading}
              onClick={state.onAction}
            >
              {state.actionLoading ? "Sending Invoice..." : state.actionLabel}
            </DesignDialogButton>
          )}
          {state.secondaryActionLabel && state.onSecondaryAction && (
            <DesignDialogButton
              tone="dark"
              disabled={state.actionLoading}
              onClick={state.onSecondaryAction}
            >
              {state.secondaryActionLabel}
            </DesignDialogButton>
          )}
        </>
      ) : undefined
    }
  >
    {state?.actionError && (
      <p role="alert" className="mt-2.5 text-sm leading-[1.55] text-[#E24C4C]">
        {state.actionError}
      </p>
    )}
    {state?.refreshWarning && (
      <p role="alert" className="mt-2.5 text-sm leading-[1.55] text-[#92400E]">
        {state.refreshWarning}
      </p>
    )}
  </DesignDialog>
);

export default MemberActionSuccessDialog;
